import React, { useState, useEffect } from 'react';
import Enumerable from 'linq';

//MUI Components
import { Autocomplete, TextField } from '@mui/material';

//Utilities
import { obtenerUbicacionNivel4 } from './UbicacionesFunctions';

export const SelectUbicacionNivel4 = ({ textLabel, textSinOpciones, testSeleccione, setIdElemento, idElemento = '00000000-0000-0000-0000-000000000000', idElementoPadre = '00000000-0000-0000-0000-000000000000', sesionUsuario, dispatch }) => {

    const [elemento, setElemento] = React.useState({ locLocation4Id: '00000000-0000-0000-0000-000000000000', locName: '' });
    const [listadoElementos, setListadoElementos] = useState([]);

    const LoadProperties = async () => {
        const listadoTemp = await obtenerUbicacionNivel4('', idElementoPadre, sesionUsuario, dispatch);
        setListadoElementos([{ locLocation4Id: '00000000-0000-0000-0000-000000000000', locName: testSeleccione }, ...listadoTemp]);
        cargarElemento(listadoTemp);
    };

    useEffect(() => {
        LoadProperties();
    }, [idElementoPadre]);

    useEffect(() => {
        cargarElemento(listadoElementos);
    }, [idElemento]);

    useEffect(() => {
        setIdElemento(elemento === null || elemento === undefined ? '00000000-0000-0000-0000-000000000000' : elemento.locLocation4Id);
    }, [elemento?.locLocation4Id]);

    const cargarElemento = (listado) => {
        if (idElemento !== '00000000-0000-0000-0000-000000000000') {
            if (listado.length > 0) {
                if (Enumerable.from(listado).any(x => x.locLocation4Id.toLowerCase() === idElemento.toLowerCase())) {
                    setElemento({ locLocation4Id: idElemento, locName: Enumerable.from(listado).first(x => x.locLocation4Id.toLowerCase() === idElemento.toLowerCase()).locName });
                } else {
                    setElemento({ locLocation4Id: '00000000-0000-0000-0000-000000000000', locName: testSeleccione });
                }
            } else {
                setElemento({ locLocation4Id: '00000000-0000-0000-0000-000000000000', locName: testSeleccione });
            }
        } else {
            setElemento({ locLocation4Id: '00000000-0000-0000-0000-000000000000', locName: testSeleccione });
        }
    };

    const ingresarValoresMemoriaAuto = (event, newValue) => {
        setElemento(newValue);
    };

    return (
        <Autocomplete fullWidth
            disabled={listadoElementos.length === 1}
            noOptionsText={textSinOpciones}
            value={elemento}
            id={textLabel}
            name='UbicacionNivel4-Element'
            options={listadoElementos}
            onChange={ingresarValoresMemoriaAuto}
            getOptionLabel={(option) => option.locName}
            getOptionDisabled={(option) => option.locLocation4Id === '00000000-0000-0000-0000-000000000000'}
            renderInput={(params) => <TextField name='label' {...params} label={textLabel} />}
        />
    )
}